import api from '@shared/services/api';

export const excessByEmployeeService = {
    getExcessByEmployeeById: async (id) => {
        const response = await api.get(`/hr-compensation-from-emp/${id}`);
        return response.data;
    },
    getExcessByEmployees: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        if (params.pageNumber !== undefined) queryParams.append('page', params.pageNumber);
        if (params.pageSize !== undefined) queryParams.append('size', params.pageSize);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDir) queryParams.append('sortDir', params.sortDir);
        
        // Handle search query
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-compensation-from-emp${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data;
    },
    createExcessByEmployee: async (data) => {
        const response = await api.post('/hr-compensation-from-emp', data);
        return response.data;
    },
    updateExcessByEmployee: async (id, data) => {
        const response = await api.put(`/hr-compensation-from-emp/${id}`, data);
        return response.data;
    },
    deleteExcessByEmployee: async (id) => {
        const response = await api.delete(`/hr-compensation-from-emp/${id}`);
        return response.data;
    },
    getTranslation: async (id) => {
        const response = await api.get(`/hr-compensation-from-emp/translation/${id}`);
        return response.data;
    },
    saveTranslation: async (data) => {
        const response = await api.post('/hr-compensation-from-emp/translate', data);
        return response.data;
    },
    getExcessByEmployeeReportData: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        // Hardcoded langCode as per requirements
        queryParams.append('langCode', 'en_US');
        
        // Handle search query (reason, kindOfCompensation)
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-compensation-from-emp/report${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data || [];
    }
};

